import {
  AddToListIcon,
  ClipboardIcon,
  Layers01Icon,
  NewsIcon,
  ShoppingCart01Icon,
  UserGroupIcon,
  UserMultipleIcon,
  User03Icon,
} from '@hugeicons/core-free-icons';
import { NavItem } from 'svnxii-ng-shared/components';

export const HQ_NAV_ITEMS: NavItem[] = [
  {
    title: 'Procurement',
    icon: ShoppingCart01Icon,
    children: [
      {
        title: 'Purchase Requests',
        icon: AddToListIcon,
        route: '/app/hq/purchase-requests',
      },
      { title: 'Vendors', icon: UserMultipleIcon, route: '/app/hq/vendors' },
      { title: 'Quotations', icon: NewsIcon, route: '/app/hq/purchase-quotations' },
      {
        title: 'Purchase Orders',
        icon: ShoppingCart01Icon,
        route: '/app/hq/purchase-orders',
      },
    ],
  },
  {
    title: 'Sales',
    icon: ClipboardIcon,
    children: [
      { title: 'Sales Requests', icon: ClipboardIcon, route: '/app/hq/sales-requests' },
      {
        title: 'Sales Return Requests',
        icon: ClipboardIcon,
        devFeature: true,
        route: '/app/hq/return-requests',
      },
    ],
  },
  {
    title: 'CRM',
    icon: UserGroupIcon,
    children: [
      {
        title: 'Potential Customers',
        icon: UserGroupIcon,
        route: '/app/hq/potential-customers',
      },
    ],
  },
  {
    title: 'Account',
    devFeature: true,
    icon: User03Icon,
    route: '/app/hq/notifications',
  },
];
